import { Token } from '../types';

const OMD_TOKEN_ADDRESS = import.meta.env.VITE_OMD_TOKEN_ADDRESS || '0xA7670e2e6742a18029436E262b01F7C50A863C40';

/** Contratos reemplazados — bloqueados para agregar y ocultos del historial. */
export const DEPRECATED_TOKEN_ADDRESSES = [
  '0xfDb7f73bc48C58FB13eA98D6880461FC147694fd', // OMD viejo en BSC
];
/**
 * ABI estándar para tokens ERC-20
 */
export const ERC20_ABI = [
  // Funciones básicas de ERC-20
  'function name() view returns (string)',
  'function symbol() view returns (string)',
  'function decimals() view returns (uint8)',
  'function totalSupply() view returns (uint256)',
  'function balanceOf(address owner) view returns (uint256)',
  'function transfer(address to, uint256 amount) returns (bool)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function approve(address spender, uint256 amount) returns (bool)',
  'function transferFrom(address from, address to, uint256 amount) returns (bool)',
  'event Transfer(address indexed from, address indexed to, uint256 amount)',
  'event Approval(address indexed owner, address indexed spender, uint256 amount)',
];

/**
 * Tokens populares por red blockchain
 */
export const POPULAR_TOKENS: Record<string, Omit<Token, 'balance' | 'balanceFormatted' | 'priceUSD'>[]> = {
  ethereum: [
    {
      address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      symbol: 'USDC',
      name: 'USD Coin',
      decimals: 6,
      logoUrl: '/assets/coin-logos-svg/usdc.svg',
    },
    {
      address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      symbol: 'USDT',
      name: 'Tether USD',
      decimals: 6,
      logoUrl: '/assets/coin-logos-svg/usdt.svg',
    },
    {
      address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
      symbol: 'DAI',
      name: 'Dai Stablecoin',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/dai.svg',
    },
    {
      address: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
      symbol: 'UNI',
      name: 'Uniswap',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/uni.svg',
    },
    {
      address: '0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0',
      symbol: 'MATIC',
      name: 'Polygon',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/matic.svg',
    },
    {
      address: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
      symbol: 'LINK',
      name: 'Chainlink',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/link.svg',
    },
    {
      address: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
      symbol: 'SHIB',
      name: 'Shiba Inu',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/shib.svg',
    },
  ],
  bsc: [
    {
      address: OMD_TOKEN_ADDRESS,
      symbol: 'OMD',
      name: 'OneMillionDollars',
      decimals: 8,
      logoUrl: '/assets/omd.png',
      isPrimary: true,
    },
    {
      address: '0x55d398326f99059fF775485246999027B3197955',
      symbol: 'USDT',
      name: 'Tether USD',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/usdt.svg',
    },
    {
      address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
      symbol: 'USDC',
      name: 'USD Coin',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/usdc.svg',
    },
    {
      address: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
      symbol: 'CAKE',
      name: 'PancakeSwap Token',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/uni.svg',
    },
    {
      address: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
      symbol: 'ETH',
      name: 'Ethereum Token',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/eth.svg',
    },
    {
      address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
      symbol: 'BTCB',
      name: 'Binance BTC',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/btc.svg',
    },
    {
      address: '0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD',
      symbol: 'LINK',
      name: 'Chainlink',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/link.svg',
    },
    {
      address: '0xbA2aE424d960c26247Dd6c32edC70B295c744C43',
      symbol: 'DOGE',
      name: 'Dogecoin',
      decimals: 8,
      logoUrl: '/assets/coin-logos-svg/doge.svg',
    },
    {
      address: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
      symbol: 'DAI',
      name: 'Dai Stablecoin',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/dai.svg',
    },
  ],
  polygon: [
    {
      address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
      symbol: 'USDC',
      name: 'USD Coin',
      decimals: 6,
      logoUrl: '/assets/coin-logos-svg/usdc.svg',
    },
    {
      address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
      symbol: 'USDT',
      name: 'Tether USD',
      decimals: 6,
      logoUrl: '/assets/coin-logos-svg/usdt.svg',
    },
    {
      address: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
      symbol: 'DAI',
      name: 'Dai Stablecoin',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/dai.svg',
    },
    {
      address: '0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39',
      symbol: 'LINK',
      name: 'Chainlink',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/link.svg',
    },
    {
      address: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
      symbol: 'WMATIC',
      name: 'Wrapped Matic',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/matic.svg',
    },
  ],
  arbitrum: [
    {
      address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
      symbol: 'USDC',
      name: 'USD Coin',
      decimals: 6,
      logoUrl: '/assets/coin-logos-svg/usdc.svg',
    },
    {
      address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
      symbol: 'USDT',
      name: 'Tether USD',
      decimals: 6,
      logoUrl: '/assets/coin-logos-svg/usdt.svg',
    },
    {
      address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
      symbol: 'DAI',
      name: 'Dai Stablecoin',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/dai.svg',
    },
    {
      address: '0x912CE59144191C1204E64559FE8253a0e49E6548',
      symbol: 'ARB',
      name: 'Arbitrum',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/eth.svg',
    },
    {
      address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
      symbol: 'WETH',
      name: 'Wrapped Ether',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/eth.svg',
    },
    {
      address: '0xf97f4df75117a78c1A5a0DBb814Af92458539FB4',
      symbol: 'LINK',
      name: 'Chainlink',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/link.svg',
    },
  ],
  optimism: [
    {
      address: '0x7F5c764cBc14f9669B88837ca1490cCa17c31607',
      symbol: 'USDC',
      name: 'USD Coin',
      decimals: 6,
      logoUrl: '/assets/coin-logos-svg/usdc.svg',
    },
    {
      address: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
      symbol: 'USDT',
      name: 'Tether USD',
      decimals: 6,
      logoUrl: '/assets/coin-logos-svg/usdt.svg',
    },
    {
      address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
      symbol: 'DAI',
      name: 'Dai Stablecoin',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/dai.svg',
    },
    {
      address: '0x4200000000000000000000000000000000000042',
      symbol: 'OP',
      name: 'Optimism',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/eth.svg',
    },
    {
      address: '0x4200000000000000000000000000000000000006',
      symbol: 'WETH',
      name: 'Wrapped Ether',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/eth.svg',
    },
    {
      address: '0x350a791Bfc2C21F9Ed5d10980Dad2e2638ffa7f6',
      symbol: 'LINK',
      name: 'Chainlink',
      decimals: 18,
      logoUrl: '/assets/coin-logos-svg/link.svg',
    },
  ],
  omdb: [
    {
      address: '0x0000000000000000000000000000000000000000',
      symbol: 'OMDB',
      name: 'OMDB Token',
      decimals: 18,
      isNative: true,
      logoUrl: '/assets/omdb-local-logo.png',
    },
  ],
};

/**
 * Obtiene los tokens populares para una red específica
 */
export const getPopularTokens = (networkId: string): Token[] => {
  const tokens = POPULAR_TOKENS[networkId] || [];

  if (tokens.length === 0) {
    console.log(`No hay tokens populares configurados para la red ${networkId}`);
    return [];
  }

  // Garantizar que todos los tokens tengan el campo network correctamente establecido
  return tokens.map((token) => ({
    ...token,
    network: networkId,
    balance: '0',
    balanceFormatted: '0',
  }));
};

/**
 * Obtiene el ABI para tokens ERC-20
 */
export const getERC20Abi = (): string[] => {
  return ERC20_ABI;
};
